import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DigitalClock } from '@mui/x-date-pickers/DigitalClock';
import EventIcon from '@mui/icons-material/Event';
import InputAdornment from '@mui/material/InputAdornment';
import Bs4Popper from './Bs4Popper';
import { DateTimeField } from '@mui/x-date-pickers';
import * as Bs4Utils from './Bs4Utils'
import Bs4MainDispatch from '../Bs4MainDispatch'
import {   
  isValid,
  addSeconds, startOfDay,
} from "date-fns";


const ViewBs4DateTime = React.forwardRef((props, ref) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const inputRef = React.useRef(null);
  const inputRefEvents = React.useRef({pointerTextField: false});
  const [minTime, maxTime] = React.useMemo(() => {    
    const hoursMin = parseInt(props.hoursMin);
    const hoursMax = parseInt(props.hoursMax);
    const minTime = Bs4Utils.isNullOrNaN(hoursMin) ? null : addSeconds(startOfDay(new Date()), hoursMin);
    const maxTime = Bs4Utils.isNullOrNaN(hoursMax) ? null : addSeconds(startOfDay(new Date()), hoursMax);
    return [minTime, maxTime];
  }, [props.hoursMin, props.hoursMax]);

  const handleChangeField = (newValue) => {    
    console.log('...ViewBs4DateTime...Change.Field..', Bs4Utils.toDateTime(newValue), newValue);
    if (props.onChange) props.onChange(newValue)
  }

  const handleChangeCalendar = (newValue, selectionState, selectedView) => {
    //console.log('...ViewBs4DateTime...Change.Calendar..', Bs4Utils.toDate(newValue), selectionState, selectedView);
    // if (selectionState !== SELECTION_STATE_OK) return;
    if (props.onChange) props.onChange(newValue)
  }

  const handleChangeClock = (newValue, selectionState, selectedView) => {
    //console.log('...ViewBs4DateTime...Change.Clock..', Bs4Utils.toDate(newValue), selectionState, selectedView);
    // if (selectionState !== SELECTION_STATE_OK) return;
    if (props.onChange) props.onChange(newValue)
    handleClose();
  }
  
  const handleClose = (event) => {
    console.log('...ViewBs4DateTime...Close..');
    event?.stopPropagation();
    setAnchorEl(null);
    // if (!inputRefEvents.current.pointerTextField) 
    if (props.onLeaveField) props.onLeaveField(event);
    if (props.onClose) props.onClose(event);
  }

  const handleClickPopper = (event) => {      
    event?.stopPropagation();
    if (anchorEl) handleClose();
    
    if (!isValid(props.value)) if (props.onChange) props.onChange(new Date());

    setAnchorEl(inputRef.current);
    if (props.onEnterField) props.onEnterField(event);
  }

  const handleChangeNaw = (event) => {      
    event?.stopPropagation();
    if (props.onChange) props.onChange(new Date())
    handleClose();
  }

  const handleClear = (event) => {
    event?.stopPropagation();
    if (props.onChange) props.onChange(null)
    handleClose();
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') handleClose(event);
  }

  const handleBlurInput = (event) => {
    console.log('...ViewBs4DateTime...BlurInput..');
    if (!inputRefEvents.current.pointerTextField && !anchorEl) {
      if (props.onLeaveField) props.onLeaveField();
    }
  }
  
  const disableUnderline = (props.readOnly && !(props.variant && props.variant !== 'standard')) ? {disableUnderline: true} : {};

  const {slotProps} = props;
  const {textField: textFieldAll, popper} = slotProps || {};
  const {InputProps, inputProps, ...textField} = textFieldAll || {};

  const [xx, xxXX] = Bs4MainDispatch.useBs4Locale();

  // console.log('...DigitalClockMemo...', props.llll, Bs4Utils.toDateTimeSSS(minTime), Bs4Utils.toDateTimeSSS(maxTime));

  return (
    <React.Fragment>
      <DateTimeField
        ref={ref}
        inputRef={node => {
          inputRef.current = node;
          if (props.inputRef) props.inputRef.current = node;
        }}
        {...anchorEl ? {focused: true} : {}}
        readOnly={Boolean(props.readOnly)}
        label={props.label}  
        value={props.value || null}
        fullWidth={props.fullWidth}
        helperText={props.error?.helperText}
        error={props.error?.error}
        {...textField}
        // referenceDate={new Date()}
        // clearable
        ampm={props.ampm || false}
        onChange={handleChangeField}        
        format="yyyy-MM-dd HH:mm"        
        InputLabelProps={props.InputLabelProps} 
        slotProps={{          
          InputProps: {         
            ...InputProps,     
            ...disableUnderline,              
            onBlur: handleBlurInput,
            onPointerEnter:(e) => inputRefEvents.current.pointerTextField = true,
            onPointerLeave:(e) => inputRefEvents.current.pointerTextField = false,
          },
          inputProps: {
            ...inputProps,
          },
        }}
        InputProps={{
          endAdornment:(
            <InputAdornment position="end">
              <IconButton edge='end' onClick={handleClickPopper}>
                <EventIcon/>
              </IconButton>
            </InputAdornment>
          )
        }}
        onKeyDown={handleKeyDown}
      />
      <Bs4Popper 
        anchorEl={anchorEl} 
        open={Boolean(anchorEl)}
        onClose={handleClose} 
        bs4kartotekaid={props.bs4KartotekaId}
        //slotProps={props?.slotProps?.popper}
        onKeyDown={handleKeyDown}
      > 
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} sx={{p: 1}}>
          <DateCalendar 
            value={props.value}
            views={['year', 'month', 'day']}
            onChange={handleChangeCalendar}
          />
          <DigitalClock
            disabled={props.disabled}
            //ampm={props.ampm}
            value={props.value}          
            timeStep={props.timeStep || 5}
            // disableIgnoringDatePartForTimeValidation
            onChange={handleChangeClock}    
            skipDisabled
            minTime={minTime}
            maxTime={maxTime}
            sx={{
              width: 'auto',
              maxHeight: 300,
            }}               
          />
        </Stack>
        <Stack direction="row" justifyContent='space-between' alignItems="center" spacing={1} sx={{p: 1}}>
          <Stack direction="row" justifyContent='flex-end' alignItems="center" spacing={1} sx={{p: 1}}>
            <Button onClick={handleClear}>{xxXX.components.MuiLocalizationProvider.defaultProps.localeText.clearButtonLabel}</Button>
            <Button onClick={handleChangeNaw}>{xxXX.components.MuiLocalizationProvider.defaultProps.localeText.todayButtonLabel}</Button>            
          </Stack>
          <Button onClick={handleClose}>{'Ok'}</Button>
        </Stack>
      </Bs4Popper>
    </React.Fragment>
  );
});

export default ViewBs4DateTime;

